import { Steps } from 'antd'
import CustomModal from 'components/global/CustomModal'
import useFormSubmit from 'helper/Hooks/formSubmit'
import React, { useEffect, useState } from 'react'
import GeneralDetails from '../ModalCotent/MentorRequest/GeneralDetails'
import CustomModalFooter from 'components/global/CustomModalFooter'
import { creationEventStore } from 'state/event/eventCreationStore'
import { useGetMentorRequestForEvent } from 'api/Event/MentorRequest'
import Spinner from 'components/Spinner'
import Shifts from '../ModalCotent/MentorRequest/Shifts'
import OtherNotes from '../ModalCotent/MentorRequest/OtherNotes'

interface RequestMentorModalProps {
  openModal: boolean
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>
  reference: 'event' | 'league' | 'class'
  referenceId: string
}

const RequestMentorModal: React.FC<RequestMentorModalProps> = ({
  openModal,
  setOpenModal,
  reference,
  referenceId,
}) => {
  const { form, handleSubmit } = useFormSubmit()
  const { Step } = Steps
  const [current, setCurrent] = useState(0)
  const {
    data: requestsForEvent,
    isLoading: isLoadingRequestsForEvent,
    isFetching: isFetchingRequestsForEvent,
    refetch: refetchRequestsForEvent,
  } = useGetMentorRequestForEvent(referenceId, reference)

  const steps = [
    {
      title: 'General Details',
    },
    {
      title: 'Shifts',
    },
    {
      title: 'Other',
    },
  ]

  const handleBack = () => {
    setCurrent(current - 1)
  }

  useEffect(() => {
    refetchRequestsForEvent()
  }, [referenceId])

  return (
    <>
      <CustomModal
        openModal={openModal}
        isCloseModalCustom={true}
        closeModal={() => setOpenModal(false)}
        title="Request a mentor"
        width={800}
        footer={
          current == 2 ? (
            false
          ) : (
            <CustomModalFooter
              multibutton={current === 0 ? false : true}
              btnAlignment="justify-between"
              btnText={
                current === 0
                  ? 'Next'
                  : current === 2
                  ? 'Back,Submit'
                  : 'Back,Next'
              }
              btnType="primary"
              closeModal={handleBack}
              onSubmit={handleSubmit}
            />
          )
        }
      >
        <Steps current={current}>
          {steps.map(item => (
            <Step
              key={item.title}
              className="step-styling"
              title={item.title}
            />
          ))}
        </Steps>

        {isLoadingRequestsForEvent || isFetchingRequestsForEvent ? (
          <div className="py-40px flex justify-center">
            <Spinner />
          </div>
        ) : (
          <>
            {current === 0 && (
              <GeneralDetails
                form={form}
                setCurrentStep={setCurrent}
                reference={reference}
                referenceId={referenceId}
                prevData={requestsForEvent}
              />
            )}
            {current === 1 && (
              <Shifts
                form={form}
                prevData={requestsForEvent}
                setCurrentStep={setCurrent}
              />
            )}
            {current === 2 && (
              <OtherNotes
                form={form}
                prevData={requestsForEvent}
                setCurrentStep={setCurrent}
                setOpenModal={setOpenModal}
              />
            )}
          </>
        )}
      </CustomModal>
    </>
  )
}

export default RequestMentorModal
